/* ============================================================
   BioActive+ FAQ — section behaviour (vanilla JS, no deps)
   Progressive enhancement over server-rendered Liquid markup.
   Re-inits on Shopify theme-editor section load/select events.
   ============================================================ */
(function () {
  function initFaq(root) {
    if (!root || root.dataset.faqInit === "1") return;
    root.dataset.faqInit = "1";

    var catButtons = Array.prototype.slice.call(root.querySelectorAll("[data-cat-btn]"));
    var groups = Array.prototype.slice.call(root.querySelectorAll(".faq__catGroup"));
    var items = Array.prototype.slice.call(root.querySelectorAll(".faq__item"));
    var slots = Array.prototype.slice.call(root.querySelectorAll(".faq__slot"));
    var sideCap = root.querySelector(".faq__sideCap");
    var searchWrap = root.querySelector(".faq__search");
    var input = root.querySelector(".faq__search input");
    var clearBtn = root.querySelector(".faq__clear");
    var hint = root.querySelector(".faq__hint");
    var hintDefault = hint ? hint.textContent : "";
    var resultMeta = root.querySelector(".faq__resultMeta");
    var empty = root.querySelector(".faq__empty");

    var firstCat = catButtons.length ? catButtons[0].getAttribute("data-cat") : null;
    var activeCat = firstCat;

    /* ---- cache original text for highlight restore ---- */
    items.forEach(function (it) {
      var q = it.querySelector(".faq__qtext");
      var a = it.querySelector(".faq__answerText");
      if (q) q.setAttribute("data-orig", q.textContent);
      if (a) a.setAttribute("data-orig", a.textContent);
    });

    function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }

    function highlight(el, q) {
      if (!el) return;
      var orig = el.getAttribute("data-orig") || el.textContent;
      if (!q) { el.textContent = orig; return; }
      var re = new RegExp("(" + escapeRe(q) + ")", "ig");
      el.innerHTML = orig.replace(/[&<>]/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c];
      }).replace(re, '<mark class="faq__mark">$1</mark>');
    }

    /* ---- accordion ---- */
    function closeItem(it) {
      var ans = it.querySelector(".faq__answer");
      it.classList.remove("is-open");
      if (ans) ans.style.height = "0px";
      var btn = it.querySelector(".faq__q");
      if (btn) btn.setAttribute("aria-expanded", "false");
    }
    function openItem(it) {
      var ans = it.querySelector(".faq__answer");
      var inner = it.querySelector(".faq__answerInner");
      it.classList.add("is-open");
      if (ans && inner) ans.style.height = inner.scrollHeight + "px";
      var btn = it.querySelector(".faq__q");
      if (btn) btn.setAttribute("aria-expanded", "true");
    }
    items.forEach(function (it) {
      var btn = it.querySelector(".faq__q");
      if (!btn) return;
      btn.addEventListener("click", function () {
        var isOpen = it.classList.contains("is-open");
        // single-open within the same visible scope
        items.forEach(function (other) { if (other !== it) closeItem(other); });
        if (isOpen) closeItem(it); else openItem(it);
      });
    });
    // keep open heights correct on resize
    window.addEventListener("resize", function () {
      items.forEach(function (it) {
        if (it.classList.contains("is-open")) {
          var ans = it.querySelector(".faq__answer");
          var inner = it.querySelector(".faq__answerInner");
          if (ans && inner) ans.style.height = inner.scrollHeight + "px";
        }
      });
    });

    /* ---- feedback ---- */
    Array.prototype.slice.call(root.querySelectorAll(".faq__fb")).forEach(function (fb) {
      var ask = fb.querySelector(".faq__fbask");
      var thanks = fb.querySelector(".faq__fbthanks");
      fb.querySelectorAll(".faq__fbbtn").forEach(function (b) {
        b.addEventListener("click", function () {
          var vote = b.getAttribute("data-vote");
          if (ask) ask.setAttribute("hidden", "");
          if (thanks) {
            thanks.textContent = vote === "up"
              ? "\u2713 Thanks for the feedback."
              : "Noted \u2014 we\u2019ll improve this answer.";
            thanks.removeAttribute("hidden");
          }
          // Hook point: send to analytics here if desired.
          if (window.dispatchEvent) {
            window.dispatchEvent(new CustomEvent("faq:feedback", {
              detail: { question: b.getAttribute("data-q") || "", vote: vote }
            }));
          }
        });
      });
    });

    /* ---- category switching ---- */
    function setActiveCat(cat) {
      activeCat = cat;
      catButtons.forEach(function (b) {
        b.classList.toggle("is-active", b.getAttribute("data-cat") === cat);
      });
      groups.forEach(function (g) {
        g.hidden = g.getAttribute("data-cat") !== cat;
        var title = g.querySelector(".faq__catTitle");
        if (title) title.hidden = false;
      });
      slots.forEach(function (s) {
        s.classList.toggle("is-active", s.getAttribute("data-cat") === cat);
      });
      if (sideCap) {
        var lab = root.querySelector('[data-cat-btn][data-cat="' + cat + '"] .lab');
        sideCap.textContent = "Photo \u00b7 " + (lab ? lab.textContent : "");
      }
      items.forEach(function (it) { it.hidden = false; it.removeAttribute("data-found"); closeItem(it); });
    }

    catButtons.forEach(function (b) {
      b.addEventListener("click", function () {
        if (input) { input.value = ""; if (searchWrap) searchWrap.classList.remove("is-filled"); }
        runSearch("");
        setActiveCat(b.getAttribute("data-cat"));
      });
    });

    /* ---- search ---- */
    function matches(it, q) {
      var hay = (it.getAttribute("data-search") || "").toLowerCase();
      return hay.indexOf(q) !== -1;
    }
    function runSearch(raw) {
      var q = (raw || "").trim().toLowerCase();
      var searching = q.length > 0;
      if (searchWrap) searchWrap.classList.toggle("is-filled", searching);

      if (!searching) {
        items.forEach(function (it) {
          it.removeAttribute("data-found");
          highlight(it.querySelector(".faq__qtext"), "");
          highlight(it.querySelector(".faq__answerText"), "");
        });
        if (resultMeta) resultMeta.hidden = true;
        if (empty) empty.hidden = true;
        if (hint) hint.textContent = hintDefault;
        setActiveCat(activeCat);
        return;
      }

      var count = 0;
      items.forEach(function (it) {
        var ok = matches(it, q);
        it.hidden = !ok;
        if (ok) {
          it.setAttribute("data-found", "1");
          closeItem(it);
          highlight(it.querySelector(".faq__qtext"), q);
          highlight(it.querySelector(".faq__answerText"), q);
          count++;
        } else {
          it.removeAttribute("data-found");
        }
      });
      groups.forEach(function (g) {
        var anyVisible = g.querySelector('.faq__item[data-found]');
        g.hidden = !anyVisible;
        var title = g.querySelector(".faq__catTitle");
        if (title) title.hidden = true;
      });
      catButtons.forEach(function (b) { b.classList.remove("is-active"); });
      if (resultMeta) {
        resultMeta.hidden = false;
        resultMeta.textContent = count
          ? "Showing " + count + " matching answer" + (count === 1 ? "" : "s") + " for \u201c" + raw.trim() + "\u201d"
          : "";
      }
      if (empty) empty.hidden = count !== 0;
      if (hint) hint.textContent = count + " result" + (count === 1 ? "" : "s") + " for \u201c" + raw.trim() + "\u201d";
    }

    if (input) {
      input.addEventListener("input", function () { runSearch(input.value); });
    }
    if (clearBtn) {
      clearBtn.addEventListener("click", function () {
        if (input) input.value = "";
        runSearch("");
        if (input) input.focus();
      });
    }

    // initial state
    if (activeCat) setActiveCat(activeCat);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll(".bioactive-faq");
    Array.prototype.slice.call(nodes).forEach(initFaq);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify theme editor
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
  document.addEventListener("shopify:section:select", function (e) { initAll(e.target); });
})();
